/* Home of Wellness - CRO page behaviour */
(function () {
  document.documentElement.classList.add('how-js');
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function reveals() {
    var els = document.querySelectorAll('.how-rv:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { each(els, function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        setTimeout(function () { el.classList.add('is-in'); }, parseInt(el.getAttribute('data-rv-delay') || '0', 10));
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    each(els, function (e) { io.observe(e); });
  }

  function counters() {
    var els = document.querySelectorAll('[data-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target; io.unobserve(el);
        var raw = el.getAttribute('data-count');
        var target = parseFloat(raw), dec = (raw.split('.')[1] || '').length;
        var suffix = el.getAttribute('data-suffix') || '', t0 = null;
        function tick(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / 1100, 1);
          var v = target * (1 - Math.pow(1 - p, 3));
          el.textContent = (dec ? v.toFixed(dec) : Math.round(v).toLocaleString('en-IN')) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });
    each(els, function (e) { io.observe(e); });
  }

  function gallery() {
    var gal = document.querySelector('[data-how-gallery]');
    if (!gal) return;
    var slides = gal.querySelectorAll('.how-gal__slide');
    var thumbs = gal.querySelectorAll('.how-gal__thumb');
    each(thumbs, function (t, i) {
      t.addEventListener('click', function () {
        each(slides, function (s, n) { s.classList.toggle('is-active', n === i); });
        each(thumbs, function (x, n) { x.classList.toggle('is-active', n === i); });
      });
    });
  }

  function packs() {
    var wrap = document.querySelector('[data-how-form]');
    if (!wrap) return;
    var qtyInput = wrap.querySelector('input[name=\"quantity\"]');
    var cards = document.querySelectorAll('.how-pack');
    if (!cards.length) return;
    var ctaPrice = document.querySelectorAll('[data-how-cta-price]');
    function select(card) {
      each(cards, function (c) {
        c.classList.toggle('is-on', c === card);
        var r = c.querySelector('input[type=\"radio\"]');
        if (r) r.checked = (c === card);
      });
      if (qtyInput) qtyInput.value = card.getAttribute('data-qty') || '1';
      var total = card.getAttribute('data-total') || '';
      each(ctaPrice, function (n) { n.textContent = total; });
    }
    each(cards, function (c) { c.addEventListener('click', function () { select(c); }); });
    select(document.querySelector('.how-pack.is-on') || cards[0]);
  }

  function countdowns() {
    var els = document.querySelectorAll('[data-how-clock]');
    if (!els.length) return;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    (function tick() {
      each(els, function (el) {
        var cutoff = parseInt(el.getAttribute('data-how-clock') || '18', 10);
        var now = new Date();
        var ist = new Date(now.getTime() + (now.getTimezoneOffset() * 60000) + (5.5 * 3600000));
        var end = new Date(ist);
        end.setHours(cutoff, 0, 0, 0);
        if (end <= ist) end.setDate(end.getDate() + 1);
        var s = Math.floor((end - ist) / 1000);
        el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      });
      setTimeout(tick, 1000);
    })();
  }

  /* auto-advancing review carousel - smooth slide, pauses on hover */
  function quotes() {
    each(document.querySelectorAll('[data-how-quotes]'), function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      var track = box.querySelector('.how-quotes__track');
      var slides = box.querySelectorAll('.how-quotes__s');
      var dots = box.querySelectorAll('.how-quotes__dots i');
      if (!track || slides.length < 2) return;
      var i = 0, timer = null, paused = false;
      var delay = parseInt(box.getAttribute('data-how-quotes') || '3000', 10);
      function go(n) {
        i = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-100 * i) + '%)';
        each(dots, function (d, k) { d.classList.toggle('on', k === i); });
      }
      function start() {
        if (timer) clearInterval(timer);
        timer = setInterval(function () { if (!paused) go(i + 1); }, delay);
      }
      box.addEventListener('mouseenter', function () { paused = true; });
      box.addEventListener('mouseleave', function () { paused = false; });
      each(dots, function (d, k) { d.addEventListener('click', function () { go(k); start(); }); });
      go(0); start();
    });
  }

  /* rating strip scrolls to the reviews section */
  function rateBars() {
    each(document.querySelectorAll('[data-how-scrollto]'), function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var t = document.querySelector(btn.getAttribute('data-how-scrollto'));
        if (!t) return;
        var y = t.getBoundingClientRect().top + window.pageYOffset - 70;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  /* recommendations rail arrows */
  function recos() {
    each(document.querySelectorAll('[data-how-reco]'), function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      var rail = box.querySelector('.how-reco__rail');
      var prev = box.querySelector('.how-reco__nav--prev');
      var next = box.querySelector('.how-reco__nav--next');
      if (!rail) return;
      function step() { var c = rail.querySelector('.how-reco__c'); return c ? c.offsetWidth + 14 : 240; }
      if (prev) prev.addEventListener('click', function () { rail.scrollLeft -= step() * 2; });
      if (next) next.addEventListener('click', function () { rail.scrollLeft += step() * 2; });
    });
  }

  function toasts() {
    var host = document.querySelector('[data-how-toast]');
    if (!host) return;
    var items = [];
    try { items = JSON.parse(host.getAttribute('data-items') || '[]'); } catch (e) { return; }
    if (!items.length) return;
    var i = 0;
    function show() {
      var it = items[i % items.length]; i++;
      host.innerHTML = '<button class=\"how-toast__x\" aria-label=\"Dismiss\">&times;</button>' +
        (it.img ? '<img src=\"' + it.img + '\" alt=\"\">' : '') +
        '<div class=\"how-toast__b\"><strong>' + it.name + '</strong> left a ' + it.stars + ' star review' +
        '<span>' + it.text + '</span><em>' + it.when + '</em></div>';
      host.classList.add('is-on');
      var x = host.querySelector('.how-toast__x');
      if (x) x.addEventListener('click', function () { host.classList.remove('is-on'); host.dataset.off = '1'; });
      setTimeout(function () { host.classList.remove('is-on'); }, 6500);
    }
    setTimeout(function loop() {
      if (host.dataset.off) return;
      show();
      setTimeout(loop, 16000);
    }, 7000);
  }

  function accordions() {
    each(document.querySelectorAll('[data-how-acc]'), function (acc) {
      var btn = acc.querySelector('.how-acc__q');
      if (!btn || btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var open = acc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function reviewsMore() {
    each(document.querySelectorAll('[data-how-more]'), function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var list = document.querySelector(btn.getAttribute('data-how-more'));
        if (list) list.classList.add('is-all');
        if (btn.parentNode) btn.parentNode.removeChild(btn);
      });
    });
  }

  function boot() {
    reveals(); counters(); gallery(); packs(); countdowns();
    quotes(); rateBars(); recos(); toasts(); accordions(); reviewsMore();
  }
  ready(boot);
  document.addEventListener('shopify:section:load', boot);
})();
